import React, { useState } from 'react';
import { Mail, Phone, MapPin, Send, Instagram, Facebook, Clock } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

const Contact8 = () => {
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
    const [submitted, setSubmitted] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitted(true);
    };

    const inputStyle = {
        width: '100%', padding: '14px 16px', backgroundColor: '#FDF2F8', border: '1px solid #F9A8D4', borderRadius: '8px',
        color: '#1A1A1A', fontSize: '14px', fontFamily: "'DM Sans', sans-serif", outline: 'none', transition: 'border-color 0.3s ease',
    };

    const contactInfo = [
        { icon: Mail, label: 'Email', value: 'hello@mehak.com' },
        { icon: Phone, label: 'Phone', value: '+91 98765 43210' },
        { icon: MapPin, label: 'Address', value: 'C-Scheme, Jaipur, Rajasthan 302001' },
        { icon: Clock, label: 'Hours', value: 'Mon - Sat: 10AM - 7PM' },
    ];

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');
            .mehak-contact-input:focus { border-color: #BE185D !important; }`}</style>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-6xl mx-auto">
                        {/* Header */}
                        <div className="text-center mb-12 lg:mb-16">
                            <p className="text-sm tracking-[0.3em] uppercase mb-3 font-medium" style={{ color: '#BE185D' }}>Get In Touch</p>
                            <h1 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-3xl lg:text-5xl font-bold mb-4">Contact Us</h1>
                            <p className="text-base max-w-lg mx-auto" style={{ color: '#6B7280' }}>We would love to hear from you. Whether it is a question, suggestion, or just to say hello.</p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12">
                            {/* Contact Info */}
                            <div className="lg:col-span-2 space-y-6">
                                {contactInfo.map((info, i) => (
                                    <div key={i} className="flex items-start gap-4 p-4 rounded-xl" style={{ backgroundColor: '#FDF2F8' }}>
                                        <div className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F9A8D4' }}>
                                            <info.icon size={20} style={{ color: '#BE185D' }} />
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold mb-1">{info.label}</p>
                                            <p className="text-sm" style={{ color: '#6B7280' }}>{info.value}</p>
                                        </div>
                                    </div>
                                ))}
                                <div className="flex gap-3 pt-4">
                                    {[Instagram, Facebook].map((Icon, i) => (
                                        <a key={i} href="#" className="w-10 h-10 rounded-full flex items-center justify-center transition-all" style={{ border: '1px solid #F9A8D4', color: '#BE185D' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#BE185D'; e.currentTarget.style.color = '#FFFFFF'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#BE185D'; }}
                                        >
                                            <Icon size={18} />
                                        </a>
                                    ))}
                                </div>
                            </div>

                            {/* Form */}
                            <div className="lg:col-span-3">
                                {submitted ? (
                                    <div className="text-center py-16 rounded-xl" style={{ backgroundColor: '#FDF2F8' }}>
                                        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#F9A8D4' }}>
                                            <Send size={24} style={{ color: '#BE185D' }} />
                                        </div>
                                        <h3 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-2xl font-bold mb-2">Message Sent!</h3>
                                        <p className="text-sm" style={{ color: '#6B7280' }}>Thank you for reaching out. We will get back to you within 24 hours.</p>
                                    </div>
                                ) : (
                                    <form onSubmit={handleSubmit} className="space-y-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <input name="name" value={formData.name} onChange={handleInputChange} placeholder="Your Name" className="mehak-contact-input" style={inputStyle} required />
                                            <input name="email" type="email" value={formData.email} onChange={handleInputChange} placeholder="Email Address" className="mehak-contact-input" style={inputStyle} required />
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <input name="phone" value={formData.phone} onChange={handleInputChange} placeholder="Phone Number" className="mehak-contact-input" style={inputStyle} />
                                            <input name="subject" value={formData.subject} onChange={handleInputChange} placeholder="Subject" className="mehak-contact-input" style={inputStyle} required />
                                        </div>
                                        <textarea name="message" value={formData.message} onChange={handleInputChange} placeholder="Your Message" rows={6} className="mehak-contact-input" style={{ ...inputStyle, resize: 'vertical' }} required />
                                        <button type="submit" className="w-full py-4 rounded-lg text-sm font-semibold uppercase tracking-wider transition-all flex items-center justify-center gap-2" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}
                                            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#9D174D'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#BE185D'; }}
                                        >
                                            <Send size={16} /> Send Message
                                        </button>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Contact8;
